import React, {forwardRef} from 'react';
import styled from 'styled-components';

import {EventHandler} from '../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {
  IconButton,
  IconButtonProps,
} from '../../../../../../libs/shared/ui/src/components/buttons/iconButton';

/*
 * Props.
 */

export interface MessageViewerHeaderButtonProps extends IconButtonProps {}

/*
 * Style.
 */

const StyledButtonDiv = styled.div`
  margin: 0 3px;
`;

/*
 * Component.
 */

export const MessageViewerHeaderButton = forwardRef<HTMLDivElement, MessageViewerHeaderButtonProps>(
  (props, ref) => {
    // Prevent the message viewer header from collapsing.
    const onWrapperClick: EventHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <StyledButtonDiv ref={ref} onClick={onWrapperClick}>
        <IconButton {...props} />
      </StyledButtonDiv>
    );
  },
);
